export enum SnackbarPosition {
    top = 'TOP',
    topRight = 'TOP-RIGHT',
    topLeft = 'TOP-LEFT',
    bottom = 'BOTTOM',
    bottomRight = 'BOTTOM-RIGHT',
    bottomLeft = 'BOTTOM-LEFT',
}
